import React from "react";

export default function PlansPromoDescription({ promo, pRole }) {
  if (promo && promo.description && promo.planGroups.includes(pRole.toUpperCase())) {
    return <div className="plans-promo-description">{promo.description}</div>;
  }

  return null;
}
